module.exports = __webpack_public_path__ + "static/media/foto6.9ffd6032.jpg";